import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Button, message } from 'antd';
import { withRouter } from 'react-router-dom';
import SingleHeader from './../components/single-header';
import DailyGoodsStrategyTable from './daily-goods-strategy-table';
import goto from '@/common/goto';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import apis from './../apis';
import './index.less';
import { getQuery } from '@/common/utils';

/*****************
 * 日常活动 - 品店策略 - 商品策略 *
 *****************/
const initOptions = {
  channelId: '',
  channelType: 11, // 注意这个是写死的【9-阵地；11-日常活动】
  jobId: '',
  jobName: '',
  pageNo: 1,
  pageSize: 5,
};

const DaliyGoodsStrategy = withRouter((props) => {
  const { roomId } = useContext(ContextProviderMenus);
  const activityId = getQuery('activityId');
  const [showBtn, setShowBtn] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [options, setOptions] = useState(initOptions);

  useEffect(() => {
    if (roomId) {
      setOptions({ ...initOptions, channelId: roomId });
    }
  }, [roomId]);

  const memoizedInit = useCallback(async () => {
    if (!options?.channelId) return false;

    const { ret, msg, data } = await apis.wareGoodsStrategyList(options);
    if (ret === '0') {
      if (data && data?.data && Array.isArray(data?.data) && data?.data.length > 0) {
        setShowBtn(false);
      } else {
        setShowBtn(true);
      }
      setTableData(data);
    } else {
      message.error(`${msg || '获取异常,请您稍后重试！'}`);
    }
  }, [options]);

  useEffect(() => {
    memoizedInit();
  }, [memoizedInit]);

  /* *********业务事件及回调********* */
  /* 新建后续流程开始 */
  function dailyNewBuildGoods() {
    goto.dailyGoodsStrategyNew(roomId, activityId).push();
  }

  async function onSureGoodsNum(item) {
    const orgJobId = item?.jobId;

    if (!options?.channelId) return Promise.resolve(false);
    const {
      ret,
      data: { data },
    } = await apis.wareGoodsStrategyList(options);
    if (ret === '0' && data && Array.isArray(data) && data?.length > 0) {
      const curItemIndex = data.findIndex((item) => item?.jobId === orgJobId);
      if (curItemIndex >= 0 && data[curItemIndex]?.wareCount && Number(data[curItemIndex]?.wareCount) > 0) {
        return Promise.resolve([true, data[curItemIndex].wareCount]);
      } else {
        return Promise.resolve([false, null]);
      }
    } else {
      return Promise.resolve([false, null]);
    }
  }

  return (
    <div className="daily-goods-strategy-wrapper">
      <div className="daily-goods-strategy-main">
        <div className="daily-goods-strategy-filter">
          <SingleHeader
            title="商品策略"
            hoverText="商品策略：基于场域运营导向通过规则进行商品策略创建，可从创建后的商品策略中，再通过规则叠加形成可直接关联资源位上场的商品组"
          />
          {showBtn && (
            <Button type="primary" shape="round" onClick={() => dailyNewBuildGoods()}>
              + 新建商品策略
            </Button>
          )}
        </div>
        <div className="daily-goods-strategy-content">
          <DailyGoodsStrategyTable tableData={tableData} onSureGoodsNum={onSureGoodsNum} />
        </div>
      </div>
    </div>
  );
});

export default DaliyGoodsStrategy;
